export const eventsData = [
  [
    {
      name: 'Graph Adversarial Technology Experiment Log',
      pos: '0% 50%',
      zoom: '250%',
      image: 'Graph Adversarial Technology Experiment Log.png',
      start: '2023-11-17 10:00:00',
      end: '2023-11-27 03:59:59',
      color: '#eae4dd',
      url: 'https://www.hoyolab.com/article/22782228',
      showOnHome: true,
    },
    {
      name: "Lil' Fungi's Fun-Tastic Fiesta",
      pos: '0% 60%',
      zoom: '200%',
      image: 'fungus_mechanicus.jpg',
      start: '2023-12-06 10:00:00',
      end: '2023-12-18 03:59:59',
      color: '#5cbcad',
      url: 'https://www.hoyolab.com/article/23172422',
      showOnHome: true,
    },
    {
      name: 'Lost Riches',
      pos: '0% 50%',
      image: 'lost_riches_2.jpg',
      start: '2024-01-02 10:00:00',
      end: '2024-01-15 03:59:59',
      color: '#FFF2DC',
      zoom: '170%',
      url: 'https://www.hoyolab.com/article/23668604',
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Misty Dungeon: Realm of Water',
      pos: '0% 50%',
      zoom: '200%',
      image: 'Misty Dungeon Realm of Water.png',
      start: '2023-11-09 10:00:00',
      end: '2023-11-20 03:59:59',
      color: '#2da6b1',
      url: 'https://www.hoyolab.com/article/22800499',
      showOnHome: true,
    },
    {
      name: "Thelxie's Fantastic Adventures",
      pos: '0% 50%',
      zoom: '200%',
      image: 'Thelxies Fantastic Adventures.png',
      start: '2023-11-23 10:00:00',
      end: '2023-12-11 03:59:59',
      color: '#83abe1',
      url: 'https://www.hoyolab.com/article/23129467',
      showOnHome: true,
    },
    {
      name: 'Ley Line Overflow',
      pos: '0% 40%',
      zoom: '200%',
      image: 'leyline_overflow.jpg',
      start: '2023-12-11 04:00:00',
      end: '2023-12-18 03:59:59',
      color: '#5baced',
      url: 'https://www.hoyolab.com/article/23172422',
      showOnHome: true,
    },
    {
      name: 'Roses and Muskets',
      pos: '0% 40%',
      zoom: '200%',
      image: 'Roses and Muskets.png',
      start: '2023-12-21 10:00:00',
      end: '2024-01-08 03:59:59',
      color: '#9ac4ee',
      url: 'https://www.hoyolab.com/article/23689256',
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Chanson of Many Waters - Furina Banner',
      pos: '40% 15%',
      zoom: '200%',
      image: 'Chanson of Many Waters 1.jpg',
      start: '2023-11-08 06:00:00',
      end: '2023-11-28 17:59:59',
      color: '#95d6fb',
      url: 'https://www.hoyolab.com/article/22782167',
      showOnHome: true,
      timezoneDependent: true,
    },
    {
      name: 'Twilight Arbiter - Cyno Banner',
      pos: '40% 15%',
      zoom: '200%',
      image: 'Twilight Arbiter 3.jpg',
      start: '2023-11-28 18:00:00',
      end: '2023-12-19 14:59:59',
      color: '#d8b8f7',
      url: 'https://www.hoyolab.com/article/23172294',
      showOnHome: true,
    },
    {
      name: 'In the Name of the Rosula - Navia Banner',
      pos: '40% 17%',
      zoom: '200%',
      image: 'In the Name of the Rosula 1.png',
      start: '2023-12-20 06:00:00',
      end: '2024-01-09 17:59:59',
      color: '#f6e195',
      url: 'https://www.hoyolab.com/article/23668466',
      showOnHome: true,
      timezoneDependent: true,
    },
  ],
  [
    {
      name: 'Immaculate Pulse - Baizhu Banner',
      pos: '30% 15%',
      zoom: '200%',
      image: 'Immaculate Pulse 2.jpg',
      start: '2023-11-08 06:00:00',
      end: '2023-11-28 17:59:59',
      color: '#8fdaa0',
      url: 'https://www.hoyolab.com/article/22782167',
      showOnHome: true,
      timezoneDependent: true,
    },
    {
      name: 'Azure Excursion - Ayato Banner',
      pos: '40% 15%',
      zoom: '200%',
      image: 'Azure Excursion 3.jpg',
      start: '2023-11-28 18:00:00',
      end: '2023-12-19 14:59:59',
      color: '#90bce9',
      url: 'https://www.hoyolab.com/article/23172294',
      showOnHome: true,
    },
    {
      name: 'In the Name of the Rosula - Ayaka Banner',
      pos: '40% 17%',
      zoom: '200%',
      image: 'The Herons Court 4.png',
      start: '2023-12-20 06:00:00',
      end: '2024-01-09 17:59:59',
      color: '#FFFBF7',
      url: 'https://www.hoyolab.com/article/23668466',
      showOnHome: true,
      timezoneDependent: true,
    },
  ],
  [
    {
      name: 'Epitome Invocation - Weapon Banner',
      pos: '30% 25%',
      zoom: '150%',
      image: 'Epitome Invocation 55.jpg',
      start: '2023-11-08 06:00:00',
      end: '2023-11-28 17:59:59',
      color: '#FFAA4B',
      url: 'https://www.hoyolab.com/article/22782167',
      showOnHome: true,
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation - Weapon Banner',
      pos: '30% 25%',
      zoom: '150%',
      image: 'Epitome Invocation 56.jpg',
      start: '2023-11-28 18:00:00',
      end: '2023-12-19 14:59:59',
      color: '#FFAA4B',
      url: 'https://www.hoyolab.com/article/23172294',
      showOnHome: true,
    },
    {
      name: 'Epitome Invocation - Weapon Banner',
      pos: '30% 25%',
      zoom: '150%',
      image: 'Epitome Invocation 57.png',
      start: '2023-12-20 06:00:00',
      end: '2024-01-09 17:59:59',
      color: '#FFAA4B',
      url: 'https://www.hoyolab.com/article/23668466',
      showOnHome: true,
      timezoneDependent: true,
    },
  ],
  [
    {
      name: 'Spiral Abyss',
      image: 'spiral_abyss.jpg',
      pos: '50% 20%',
      start: '2023-11-01 04:00:00',
      end: '2023-11-16 04:00:00',
      color: '#4299E1',
      description:
        "After the active character's Normal or Charged Attack hits an opponent, that character's Normal and Charged Attack CRIT Rate is increased by 6% for 5s. This effect can be triggered once every 0.1s. Max 5 stacks. Each stack's duration is counted independently. This effect will be cleared if the character leaves the field.",
    },
    {
      name: 'Spiral Abyss',
      image: 'spiral_abyss.jpg',
      pos: '50% 20%',
      start: '2023-11-16 04:00:00',
      end: '2023-12-01 04:00:00',
      color: '#4299E1',
      description:
        "When a character's HP increases or decreases, it will be counted. When it reaches a total of 12, a shockwave will be unleashed at the character's position, dealing True DMG to nearby opponents and clearing the count. 1 such shockwave can be unleashed every 4s.",
    },
    {
      name: 'Spiral Abyss',
      image: 'spiral_abyss.jpg',
      pos: '50% 20%',
      start: '2023-12-01 04:00:00',
      end: '2023-12-16 04:00:00',
      color: '#4299E1',
      description:
        "When off-field characters deal Elemental Skill DMG to an opponent, an Uncanny Mark will be placed upon that opponent. When another active character hits a marked opponent with an attack of the same Elemental Type, a shockwave will be unleashed at that opponent's position, dealing True DMG. The Uncanny Mark lasts 5s, and Marks created through different attacks with different Elemental Types can exist independently. 1 such shockwave can be unleashed every 2s. When a character enters the field, the Uncanny Marks placed by that character on opponents will be removed.",
    },
    {
      name: 'Spiral Abyss',
      image: 'spiral_abyss.jpg',
      pos: '50% 20%',
      start: '2023-12-16 04:00:00',
      end: '2024-01-01 04:00:00',
      color: '#4299E1',
      description:
        "After a character takes the field, they will gain one stack of Soar every 2.5s. Each stack will increase the DMG dealt by this character by 8%. Max 3 stacks. A character with 3 stacks will unleash a shockwave at an opponent's position when they deal DMG to that opponent, dealing True DMG. This effect will be cleared when the character leaves the field. 1 such shockwave can be unleashed every 1s",
    },
    {
      name: 'Spiral Abyss',
      image: 'spiral_abyss.jpg',
      pos: '50% 20%',
      start: '2024-01-01 04:00:00',
      end: '2024-01-16 04:00:00',
      color: '#4299E1',
      description:
        'After a character obtains an Elemental Shard created by the Crystallize reaction, they will gain the Redoubtable state. Active characters in this state deal 15% increased DMG. This state lasts for 8s and can stack up to 3 times, with the duration of each stack counted independently.',
    },
    {
      name: 'Spiral Abyss',
      image: 'spiral_abyss.jpg',
      pos: '50% 20%',
      start: '2024-01-16 04:00:00',
      end: '2024-02-01 04:00:00',
      color: '#4299E1',
      description:
        "After a character obtains an Elemental Shard created by the Crystallize reaction, it will be counted. When the count reaches 3, a shockwave will be released at the character's location, dealing True DMG to nearby opponents, and resetting the count. 1 such shockwave can be triggered every 6s.",
    },
  ],
  [
    {
      name: "Paimon's Bargain - Bennett, Lisa, and Blackcliff",
      pos: '0% 50%',
      zoom: '150%',
      start: '2023-11-01 04:00:00',
      end: '2023-12-01 04:00:00',
      color: '#B6A1EA',
      image: 'paimon_bargain.png',
      description: 'Now selling: Bennett, Lisa, and Blackcliff Weapons.',
    },
    {
      name: "Paimon's Bargain - Bennett, Lisa, and Royal",
      pos: '0% 50%',
      zoom: '150%',
      start: '2023-12-01 04:00:00',
      end: '2024-01-01 04:00:00',
      color: '#B6A1EA',
      image: 'paimon_bargain.png',
      description: 'Now selling: Barbara, Kaeya, and Royal Weapons.',
    },
  ],
  [
    {
      name: 'Battle Pass - Whirling Waltz',
      pos: '0% 25%',
      image: 'Whirling Waltz.jpg',
      start: '2023-11-08 06:00:00',
      end: '2023-12-18 03:59:59',
      color: '#46ace8',
      url: 'https://www.hoyolab.com/article/21853732',
      timezoneDependent: true,
    },
    {
      name: 'Battle Pass - Fontinalia',
      pos: '0% 25%',
      image: 'Fontinalia.png',
      start: '2023-12-20 06:00:00',
      end: '2024-01-29 03:59:59',
      color: '#dfb790',
      url: 'https://www.hoyolab.com/article/23668604',
      timezoneDependent: true,
    },
  ],
];
